module.exports = __webpack_public_path__ + "img/oufu_50x70x10b.prt.bf533768.jpg";